const cookieAdd = require('./cookie.add');
const cookieGet = require('./cookie.get');

export default function () {
  const cookieName = 'cookieinfo';
  const submitButton = document.querySelectorAll('.js-save-cookies');
  const changeCookies = document.querySelectorAll('.js-change-cookies, a[href$="#change-cookies"]');
  const closeCookies = document.querySelector('.js-close-cookies');

  window.cookies = {};
  window.cookies.accepted = [];
  window.cookies.info = {};

  /**
   * Init
   * @private
   */
  function _init() {
    const storage = cookieGet(cookieName);
    const current = storage !== null ? storage : false;

    if ( current ) {
      try {
        JSON.parse(current);
        _validate();

      } catch (e) {
        _reset();
      }
    } else {
      _show();
    }

    // Save options
    [].forEach.call(submitButton, (function (element) {
      element.addEventListener('click', function () {
        _saveOptions(element);
      });
    }));

    // Open overlay
    if ( changeCookies ) {
      [].forEach.call(changeCookies, (function (element) {
        element.addEventListener('click', function (e) {
          _show(true);
          e.preventDefault();
        });
      }));
    }

    // Close
    if ( closeCookies ) {
      closeCookies.addEventListener('click', _hide);
    }

    // Inline cookies, trigger options
    if ( document.querySelector('.js-inline-cookies') ) {
      _triggerOptions();
    }
  }

  /**
   * Validate current state
   * @private
   */
  function _validate() {
    const cookies = _returnSavedPrefferences();
    let validated = true;

    if ( !cookies.info || !cookies.info.v || cookies.info.v !== app.privacy ) {
      validated = false;
    }

    if ( !cookies.accepted || !cookies.accepted.length ) {
      validated = false;
    }

    if ( validated ) {
      window.cookies = cookies;

      cookieAdd(cookieName, JSON.stringify(window.cookies), 365);
    } else {
      _reset();
    }
  }

  /**
   * Loop through preferences
   * @private
   */
  function _triggerOptions() {
    const cookies = _returnSavedPrefferences();

    if ( cookies !== null && cookies.accepted && cookies.accepted.length ) {
      for ( let i = 0; i < cookies.accepted.length; i++ ) {
        const inputs = document.querySelectorAll('[name="cookie-accept"][value="' + cookies.accepted[i] + '"]');

        [].forEach.call(inputs, (function (input) {
          input.checked = true;
        }));
      }
    }
  }

  /**
   * Save the selected options
   * @private
   */
  function _saveOptions(button) {
    const cookies = button.parentNode.querySelectorAll('[name="cookie-accept"]');
    const info = {
      v: app.privacy,
      accepted: window.cookies.info.accepted || new Date(),
      updated: new Date()
    };
    let accepted = [];

    if ( cookies ) {
      [].forEach.call(cookies, (function (accept) {
        if ( accepted.indexOf(accept.value) < 0 ) {
          accepted.push(accept.value);
        }
      }));
    }

    // Store
    window.cookies.accepted = accepted;
    window.cookies.info = info;

    // Set
    cookieAdd(cookieName, JSON.stringify(window.cookies), 365);

    // Reload
    window.location.reload();
  }

  /**
   * Return saved cookie preferences
   * @returns {Array}
   * @private
   */
  function _returnSavedPrefferences() {
    const storage = cookieGet(cookieName);

    return storage ? JSON.parse(cookieGet(cookieName)) : null;
  }

  /**
   * Reset;
   * Remove localstorage and show options again
   * @private
   */
  function _reset() {
    cookieAdd(cookieName, null, -1);
    _show();
  }
  /**
   * Show the overlay
   * @param canBeClosed
   * @private
   */
  function _show(canBeClosed) {
    document.body.className += ' show-cookie-overlay';

    if ( canBeClosed ){
      document.body.className += ' show-cookie-overlay--closeable';
    }

    _triggerOptions();
  }

  /**
   * Remove classes from body to hide overlay
   * @private
   */
  function _hide(e) {
    e.preventDefault();
    document.body.className = document.body.className.replace(/\bshow-cookie-overlay--closeable|show-cookie-overlay\b/g, '');
  }

  // Start
  if ( submitButton ) {
    _init();
  }
};
